<template>
    <section class="main">
        <div v-show="isLoading">
        <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <div class="grid-container">
                <div class="action action--page">
                    <router-link
                        :to="{ name : 'mixingplants' }"
                        tag="button"
                        class="button button--prev"
                        :title="$t('prev_page')"
                        tabindex="-1"
                        >{{ $t('prev_page') }}</router-link>

                    <h1>{{ object.name }}</h1>
                </div>
            </div>

            <div v-show="hasLoadingError">
                <div class="grid-container">
                <p class="text-center">{{ loadingError }}</p>
                </div>
            </div>

            <div class="grid-container">
                <div class="grid-x">
                    <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                        <v-action-buttons :items="getActionButtons" />
                        <div class="box">
                            <div class="grid-x">
                                <div class="cell small-12 medium-6">

                                    <h2 class="u-extra-small-margin--bottom">Geschäftsadresse</h2>
                                    <p class="u-extra-linehight">
                                        {{ object.name }} <br>
                                        {{ object.address.street }} {{ object.address.housenumber }} <br>
                                        {{ object.address.zipcode }} {{ object.address.city }} <br>
                                        {{ object.address.country }}
                                    </p>
                                    <h2 class="u-extra-small-margin--bottom">Kontakt Mischanlage</h2>
                                    <p class="u-extra-linehight">
                                        Ansprechpartner: {{ object.contact_person }} <br>
                                        Telefon: {{ object.phone }}</br>
                                        Fax: {{ object.fax }}</br>
                                        E-Mail: <a :href="`mailto:${object.email}`">{{ object.email }}</a>
                                    </p>
                                    <h2 class="u-extra-small-margin--bottom">Kontakt Vertrieb</h2>
                                    <p class="u-extra-linehight">
                                        Ansprechpartner: {{ object.sales_contact_person }} <br>
                                        Telefon: {{ object.sales_contact_phone }}</br>
                                        E-Mail: <a :href="`mailto:${object.sales_contact_email}`">{{ object.sales_contact_email }}</a>
                                    </p>
                                    <p>
                                        Bewertung:
                                            <span v-if="!object.ranking"><i>keine</i></span>
                                            <span v-else :class="'c-ranking c-ranking--' + object.ranking"></span>
                                    </p>

                                    <div class="u-extra-medium-margin--bottom">
                                      <v-ranking-legend></v-ranking-legend>
                                    </div>
                                </div>
                                <div class="cell small-12 medium-6 u-extra-medium-margin--bottom">
                                    <div class="form-block">
                                        <div class="form-group">
                                            <div class="form-control form-control--maps">
                                                <v-google-map
                                                    :address="objectAddress"
                                                    :resize="!isLoading"
                                                    :lat="object.lat"
                                                    :lon="object.lon"
                                                    :panControl="true"
                                                    :zoomControl="true"
                                                    :zoom="12"
                                                    :useFitBounds="false"
                                                    @marker="getMarker"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import PageHeader from "./../partials/PageHeader";
import PageLoading from "./../partials/PageLoading";
import ActionButtons from "./../partials/Foundation/ActionButtons";
import RankingLegend from "./../partials/Rankinglegend.vue";
import GoogleMap from "./../partials/GoogleMap";

export default {
    name: "MixingplantView",
    data: function()
    {
      return {
        loading: false,
        loadingError: null,
        object: {
            id: null,
            address: {
                city: null,
                country_code: null,
                housenumber: null,
                region: null,
                street: null,
                zipcode: null,
                country: null
            },
            contactperson: null,
            email: null,
            fax: null,
            lat: null,
            lon: null,
            modifiedon: null,
            name: null,
            phone: null,
            ranking: null,

        }
      };
    },

    components: {
        vPageHeader: PageHeader,
        vPageLoading: PageLoading,
        vActionButtons: ActionButtons,
        vRankingLegend: RankingLegend,
        vGoogleMap: GoogleMap,
    },

    computed: {
        objectAddress () {
            // the backslash \ prevents JavaScript from adding line breaks in the string template literal
            return `\
                ${this.object.address.street ?? ''} \
                ${this.object.address.housenumber ?? ''} \
                ${this.object.address.city ?? ''} \
                ${this.object.address.zipcode ?? ''} \
            `.trim()
        },

        getActionButtons: function () {
            let buttons = [];

            if (this.$store.getters.userHasPermission("mixingplant_update")) {
                buttons.push({
                    action: "update",
                    router: {
                        name: "update-mixingplant",
                    },
                });
            }

            buttons.push({
                action: "cancel",
                router: {
                    name: "mixingplants",
                },
            });

            return buttons;
        },

        isLoading : function () {
            return this.loading;
        },

        hasLoadingError : function () {
            return this.loadingError !== null;
        },

        getPageTile : function () {
            if (this.object.name) {
                return this.object.name;
            }

            return '';
        },

    },

    created () {
        this.getMixingPlant();
    },

    methods: {
        /**
         * Get our mixing plant
         */
        getMixingPlant () {
            this.loading = true;

            this.$api
                .clearParams()
                .get(`mixingplants/${this.$route.params.mixingplant}/get`)
                .then(response => {
                    this.object = response.data.data;
                })
                .catch(error => {
                    if (error.response !== undefined) {
                        this.loadingError = error.response.data.message;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getMarker (marker) {
            if (marker) {
                this.object.lat = marker.lat;
                this.object.lon = marker.lng;
            }
        },
    }
 }

</script>
